/**
 * Normalize niches from GET /social/niches/available.
 * API returns { niches: [{ slug, label }, ...] } (or legacy string[]).
 */
export const formatNicheLabel = (slug) =>
  String(slug)
    .split(/[_-]/)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");

export const getNicheSlug = (niche) => {
  if (typeof niche === "string") return niche.toLowerCase();
  if (niche && typeof niche === "object") {
    return String(niche.slug || niche.value || niche.id || niche.name || "").toLowerCase();
  }
  return "";
};

export const getNicheLabel = (niche, slugLookup = null) => {
  if (niche && typeof niche === "object" && niche.label) return niche.label;
  const slug = getNicheSlug(niche);
  if (slugLookup?.[slug]) return slugLookup[slug];
  return formatNicheLabel(slug);
};

/** @returns {{ slug: string, label: string }[]} */
export const normalizeAvailableNiches = (response) => {
  const raw = Array.isArray(response) ? response : response?.niches || [];
  return raw
    .map((niche) => {
      const slug = getNicheSlug(niche);
      if (!slug) return null;
      return {
        slug,
        label: getNicheLabel(niche),
      };
    })
    .filter(Boolean);
};

export const buildNicheLabelMap = (niches) =>
  Object.fromEntries(niches.map(({ slug, label }) => [slug, label]));
